/*
 * Bellboxer BeatPad product page — vanilla-JS port of the approved design's
 * component logic (state = { bundle: 2, idx: 0, showBar: false, openFaq: 0, featIdx: 0 }).
 * All visual values set here are the exact values the original render logic computed.
 * Cart: Shopify Ajax Cart API (no tokens). Checkout: Shopify's own /checkout.
 */
(function () {
  'use strict';

  var ON = { border: '#1E6BFF', bg: '#EEF4FF', dot: '#1E6BFF' };
  var OFF = { border: '#D9E1F2', bg: '#FFFFFF', dot: '#FFFFFF' };
  var DOT_ON = { w: '18px', bg: '#1E6BFF' };
  var DOT_OFF = { w: '7px', bg: '#C9D5F2' };

  function init(root) {
    if (root.__bpInit) return;
    root.__bpInit = true;
    var sid = root.getAttribute('data-bp-root');
    var cfg = (window.BEATPAD || {})[sid];
    if (!cfg) return;

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // ---- variant lookup (resolve every bundle against real Shopify variants)
    var variantsById = {};
    (cfg.variants || []).forEach(function (v) { variantsById[v.id] = v; });
    function bundleAvailable(n) {
      var b = cfg.bundles[n];
      var v = b && variantsById[b.variantId];
      return !!(b && v && v.available && b.available);
    }

    var state = { bundle: cfg.defaultBundle || 2, idx: 0, showBar: false, openFaq: 0, featIdx: 0 };
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)');

    // =========================================================== render
    var ctas = $$('[data-bp-cta]');
    ctas.forEach(function (a) { a.setAttribute('data-bp-label', a.textContent); });

    function renderBundle() {
      [1, 2].forEach(function (n) {
        var st = state.bundle === n ? ON : OFF;
        var btn = $('[data-bp-bundle="' + n + '"]');
        var dot = $('[data-bp-radio="' + n + '"]');
        if (btn) {
          btn.setAttribute('aria-checked', state.bundle === n ? 'true' : 'false');
          btn.style.borderColor = st.border;
          btn.style.background = st.bg;
        }
        if (dot) {
          dot.style.borderColor = st.border;
          dot.style.background = st.dot;
        }
      });
      var b = cfg.bundles[state.bundle];
      $$('[data-bp-sel-label]').forEach(function (el) { el.textContent = b.label; });
      $$('[data-bp-sel-price]').forEach(function (el) { el.textContent = b.price; });
      var avail = bundleAvailable(state.bundle);
      ctas.forEach(function (a) {
        a.setAttribute('href', b.href);
        a.textContent = avail ? a.getAttribute('data-bp-label') : 'Sold Out';
        a.setAttribute('aria-disabled', avail ? 'false' : 'true');
        a.style.opacity = avail ? '' : '0.55';
        a.style.cursor = avail ? '' : 'not-allowed';
      });
    }

    function renderGallery() {
      $$('[data-bp-dot]').forEach(function (d) {
        var on = +d.getAttribute('data-bp-dot') === state.idx;
        d.style.width = on ? DOT_ON.w : DOT_OFF.w;
        d.style.background = on ? DOT_ON.bg : DOT_OFF.bg;
      });
      $$('[data-bp-thumb]').forEach(function (t) {
        var on = +t.getAttribute('data-bp-thumb') === state.idx;
        t.style.borderColor = on ? '#1E6BFF' : 'transparent';
        t.style.opacity = on ? '1' : '0.72';
      });
    }

    function renderFeatDots() {
      $$('[data-bp-featdot]').forEach(function (b) {
        var on = +b.getAttribute('data-bp-featdot') === state.featIdx;
        var s = b.firstElementChild;
        if (!s) return;
        s.style.width = on ? DOT_ON.w : DOT_OFF.w;
        s.style.background = on ? DOT_ON.bg : DOT_OFF.bg;
      });
    }

    function renderFaq() {
      $$('[data-bp-faq]').forEach(function (btn) {
        var i = +btn.getAttribute('data-bp-faq');
        var open = state.openFaq === i;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var icon = btn.querySelector('[data-bp-faq-icon]');
        if (icon) icon.style.transform = 'rotate(' + (open ? '180deg' : '0deg') + ')';
        var body = btn.nextElementSibling;
        if (body && body.hasAttribute('data-bp-faq-body')) body.style.gridTemplateRows = open ? '1fr' : '0fr';
      });
    }

    var bar = $('[data-bp-bar]');
    var barLink = bar && bar.querySelector('a');
    function renderBar() {
      if (!bar) return;
      bar.style.transform = 'translateY(' + (state.showBar ? '0%' : '110%') + ')';
      bar.setAttribute('aria-hidden', state.showBar ? 'false' : 'true');
      if (barLink) barLink.setAttribute('tabindex', state.showBar ? '0' : '-1');
    }

    // =========================================================== bundles
    $$('[data-bp-bundle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.bundle = +btn.getAttribute('data-bp-bundle');
        renderBundle();
      });
    });

    // =========================================================== add to cart -> checkout
    var busy = false;
    function postJSON(url, data) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(data)
      }).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || ('HTTP ' + r.status)); });
        return r.json();
      });
    }
    function buy(e) {
      e.preventDefault();
      var n = state.bundle;
      var b = cfg.bundles[n];
      if (!bundleAvailable(n) || busy) return;
      busy = true;
      ctas.forEach(function (a) { a.setAttribute('aria-busy', 'true'); });
      var r = window.BEATPAD_ROUTES || {};
      var cartUrl = (r.cart_url || '/cart') + '.js';
      var addUrl = (r.cart_add_url || '/cart/add') + '.js';
      var changeUrl = (r.cart_change_url || '/cart/change') + '.js';
      fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // Mirror the design's cart-permalink behaviour for this product: the cart ends up with
          // exactly the chosen bundle of this product (other products in the cart are untouched).
          var chain = Promise.resolve();
          var found = null;
          (cart.items || []).forEach(function (item) {
            if (item.product_id !== cfg.productId) return;
            if (item.variant_id === b.variantId && !found) { found = item; return; }
            chain = chain.then(function () { return postJSON(changeUrl, { id: item.key, quantity: 0 }); });
          });
          return chain.then(function () {
            if (found) {
              if (found.quantity === b.quantity) return null;
              return postJSON(changeUrl, { id: found.key, quantity: b.quantity });
            }
            return postJSON(addUrl, { items: [{ id: b.variantId, quantity: b.quantity }] });
          });
        })
        .then(function () { window.location.href = r.checkout_url || '/checkout'; })
        .catch(function (err) {
          // Fallback: Shopify cart permalink (same real variant + quantity) → checkout.
          if (window.console) console.warn('[BeatPad] Ajax cart failed, using cart permalink', err);
          window.location.href = b.href;
        });
    }
    ctas.forEach(function (a) { a.addEventListener('click', buy); });
    window.addEventListener('pageshow', function () {
      busy = false;
      ctas.forEach(function (a) { a.removeAttribute('aria-busy'); });
    });

    // =========================================================== gallery
    var gal = $('[data-bp-gallery]');
    if (gal) {
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        if (i !== state.idx) { state.idx = i; renderGallery(); }
      }, { passive: true });
    }
    $$('[data-bp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-bp-thumb');
        if (gal) gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
        state.idx = i;
        renderGallery();
      });
    });

    // =========================================================== feature images
    var feat = $('[data-feat]');
    if (feat) {
      feat.addEventListener('scroll', function () {
        var k = feat.children;
        if (!k.length) return;
        var step = k.length > 1 ? k[1].offsetLeft - k[0].offsetLeft : 1;
        var max = feat.scrollWidth - feat.clientWidth;
        var i = Math.round(feat.scrollLeft / step);
        if (feat.scrollLeft >= max - 2) i = k.length - 1;
        i = Math.max(0, Math.min(k.length - 1, i));
        if (i !== state.featIdx) { state.featIdx = i; renderFeatDots(); }
      }, { passive: true });
    }
    $$('[data-bp-featdot]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-bp-featdot');
        var c = feat && feat.children[i];
        if (c) feat.scrollTo({ left: c.offsetLeft - feat.children[0].offsetLeft, behavior: 'smooth' });
      });
    });

    // =========================================================== FAQ
    $$('[data-bp-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = +btn.getAttribute('data-bp-faq');
        state.openFaq = state.openFaq === i ? -1 : i;
        renderFaq();
      });
    });

    // =========================================================== sticky bar
    var mainBuy = $('[data-main-buy]');
    function checkBar() {
      if (!mainBuy) return;
      var show = mainBuy.getBoundingClientRect().bottom < 0;
      if (show !== state.showBar) { state.showBar = show; renderBar(); }
    }
    window.addEventListener('scroll', checkBar, { passive: true });
    document.addEventListener('scroll', checkBar, { passive: true, capture: true });
    window.addEventListener('resize', checkBar);

    // =========================================================== ticker + clip carousel (rAF)
    var tickerPaused = false;
    var tickerWrap = $('[data-bp-ticker-wrap]');
    if (tickerWrap) {
      var pt = function () { tickerPaused = true; };
      var rt = function () { tickerPaused = false; };
      tickerWrap.addEventListener('mouseenter', pt);
      tickerWrap.addEventListener('mouseleave', rt);
      tickerWrap.addEventListener('touchstart', pt, { passive: true });
      tickerWrap.addEventListener('touchend', rt);
      tickerWrap.addEventListener('touchcancel', rt);
    }

    var car = $('[data-car]');
    var carPaused = false, resumeT = null, pos = null;
    function half(el) {
      var k = el.children; var n = 7;
      if (k.length < n * 3) return 0;
      return k[n].offsetLeft - k[0].offsetLeft;
    }
    if (car) {
      var pauseCar = function () { clearTimeout(resumeT); carPaused = true; };
      var resumeCar = function () {
        clearTimeout(resumeT);
        resumeT = setTimeout(function () { carPaused = false; pos = car.scrollLeft; }, 1200);
      };
      car.addEventListener('pointerdown', pauseCar);
      car.addEventListener('pointerup', resumeCar);
      car.addEventListener('pointercancel', resumeCar);
      car.addEventListener('touchstart', pauseCar, { passive: true });
      car.addEventListener('touchend', resumeCar);
      car.addEventListener('mouseenter', pauseCar);
      car.addEventListener('mouseleave', resumeCar);
      car.addEventListener('scroll', function () {
        var h = half(car);
        if (!h) return;
        if (car.scrollLeft < h * 0.5) { car.scrollLeft += h; pos = car.scrollLeft; }
        else if (car.scrollLeft >= h * 2.5) { car.scrollLeft -= h; pos = car.scrollLeft; }
      }, { passive: true });
    }

    var speed = cfg.carouselSpeed == null ? 35 : cfg.carouselSpeed;
    var last = performance.now();
    var tx = 0;
    var tk = $('[data-ticker]');
    function tick(t) {
      var dt = Math.min(64, t - last); last = t;
      if (tk && tk.children.length > 1) {
        var w = tk.children[1].offsetLeft - tk.children[0].offsetLeft;
        if (w > 0 && !tickerPaused && !rm.matches && !document.hidden) {
          tx += 40 * dt / 1000;
          if (tx >= w) tx -= w;
          tk.style.transform = 'translate3d(' + (-tx) + 'px,0,0)';
        }
      }
      if (car) {
        var h = half(car);
        if (pos == null && h > 0) { pos = h; car.scrollLeft = h; }
        if (!carPaused && !rm.matches && h > 0 && !document.hidden) {
          if (Math.abs(car.scrollLeft - pos) > 2) pos = car.scrollLeft;
          pos += speed * dt / 1000;
          if (pos >= h * 2) pos -= h;
          car.scrollLeft = pos;
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    // =========================================================== clips (lazy load + play in view)
    function loadClip(el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      if (el.tagName === 'VIDEO') {
        [['mp4', 'video/mp4'], ['webm', 'video/webm']].forEach(function (p) {
          if (!el.dataset[p[0]]) return;
          var s = document.createElement('source'); s.src = el.dataset[p[0]]; s.type = p[1]; el.appendChild(s);
        });
        el.load();
      } else {
        el.dataset.poster = el.getAttribute('src');
        el.setAttribute('src', el.dataset.anim);
      }
    }
    function playClip(el) {
      if (el.tagName === 'VIDEO') { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
      else if (el.dataset.anim && el.getAttribute('src') !== el.dataset.anim) el.setAttribute('src', el.dataset.anim);
    }
    function pauseClip(el) {
      if (el.tagName === 'VIDEO') { if (!el.paused) el.pause(); }
      else if (el.dataset.poster) el.setAttribute('src', el.dataset.poster);
    }
    var clips = $$('video[data-clip], img[data-clip-img]');
    if (clips.length && 'IntersectionObserver' in window) {
      var clipIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (v.tagName === 'VIDEO') { v.muted = true; v.setAttribute('playsinline', ''); }
          if (en.isIntersecting) {
            if (rm.matches && !v.dataset.userPlay) return;
            loadClip(v); playClip(v);
          } else if (v.tagName === 'VIDEO') {
            pauseClip(v);
          }
        });
      }, { rootMargin: '200px 300px' });
      clips.forEach(function (v) { if (v.tagName === 'VIDEO') v.muted = true; clipIO.observe(v); });
    }
    $$('[data-bp-clip-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (!rm.matches) return;
        var v = card.querySelector('video[data-clip], img[data-clip-img]');
        if (!v) return;
        v.dataset.userPlay = '1';
        if (!v.dataset.loaded) { loadClip(v); playClip(v); return; }
        var playing = v.tagName === 'VIDEO' ? !v.paused : v.getAttribute('src') === v.dataset.anim;
        if (playing) pauseClip(v); else playClip(v);
      });
    });

    // initial render (matches the server-rendered default state; also applies stock status)
    renderBundle(); renderGallery(); renderFeatDots(); renderFaq(); renderBar(); checkBar();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bp-root]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
